// Mock authentication service for testing
const mockAuthService = {
  login: (email: string, password: string): Promise<any> => {
    return new Promise((resolve) => {
      // Simulate API delay
      setTimeout(() => {
        // Accept any credentials for demo purposes
        const response = {
          success: true,
          token: 'demo-jwt-token-' + Date.now(),
          user: {
            id: Date.now().toString(),
            firstName: email.split('@')[0],
            lastName: 'Demo',
            email: email,
            role: 'user'
          }
        };
        resolve(response);
      }, 500);
    });
  },
  
  getCurrentUser: (): Promise<any> => {
    return new Promise((resolve, reject) => {
      const storedUser = localStorage.getItem('user');
      
      if (storedUser) {
        resolve({ user: JSON.parse(storedUser) });
      } else {
        reject(new Error('User not found'));
      }
    });
  },
  
  register: (name: string, email: string, password: string): Promise<any> => {
    return new Promise((resolve) => {
      // Simulate API delay
      setTimeout(() => {
        const nameParts = name.split(' ');
        const response = {
          success: true,
          token: 'demo-jwt-token-' + Date.now(),
          user: {
            id: Date.now().toString(),
            firstName: nameParts[0] || 'User',
            lastName: nameParts.slice(1).join(' ') || 'Demo',
            email,
            role: 'user'
          }
        };
        resolve(response);
      }, 500);
    });
  }
};

export default mockAuthService; 